import * as api from '@lib/api';
import { addressAtom } from '@src/state';
import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { ContentView } from '../components/content-view.styled';
import { Form, Title } from '../components/form.styled';
import PageView from '../components/page-view';
import { RetryAddressButton } from '../components/retry-address-button';
import { useAnalytics } from '../lib/analytics';
import * as styled from './need-more-details.styled';

const NeedMoreDetails: React.FC<{
    onRetry: () => void;
    scrollTarget: React.RefObject<HTMLDivElement>;
}> = ({ onRetry, scrollTarget }) => {
    const address = useRecoilValue(addressAtom);
    const analytics = useAnalytics();

    useEffect(() => {
        api.emitAnalytics('step-need-more-info', analytics);
    }, []);

    return (
        <PageView dataCy="need-more-details" scrollTarget={scrollTarget} imageVariant={'normal'}>
            <ContentView>
                <Form>
                    <Title>Looks like we need some more info</Title>
                    <styled.Subtitle>
                        <span>{address ?? ''}</span>
                        <RetryAddressButton onRetry={onRetry} />
                    </styled.Subtitle>
                    <styled.Input>
                        <styled.Paragraph>
                            We’ll be in touch to finish up your income estimate.
                        </styled.Paragraph>
                    </styled.Input>
                </Form>
            </ContentView>
        </PageView>
    );
};

export default NeedMoreDetails;
